import userAPI from '@/services/api/institute/user'

const User = {
	namespaced: true,
	state: () => ({
		user: {
			name: undefined,
			id: undefined,
			phone: undefined,
			email: undefined,
			type: undefined,
			snsId: undefined,
			isMaster: undefined,
			isPush: undefined,
			language: undefined,
			isCertificated: undefined,
			isLegacyUser: undefined,
		},
		userPermission: null,
		institute: undefined,
		license: null,
	}),
	getters: {
		hasInstitutionId: state => {
			return state.institute !== undefined
		},
	},
	mutations: {
		initUserInfo: state => {
			state.userName = undefined
			state.userId = undefined
			state.institutionId = undefined
		},
		setUser: (state, payload) => {
			state.user = payload
		},
		setInstitute: (state, payload) => {
			state.institute = payload
		},
		setInstituteId: (state, payload) => {
			state.institutionId = payload
		},
		setUserPermission: (state, payload) => {
			state.userPermission = payload
		},
		setLicense: (state, license) => {
			state.license = license
		},
	},
	actions: {
		loadUserInfo: async ({ commit }) => {
			const response = await userAPI.lookupUserInfo()
			commit('setUser', response.data)
		},
		loadUserInstituteInfo: async ({ commit }) => {
			const response = await userAPI.lookupUserInstInfo()
			commit('setInstitute', { ...response.data })
		},
		loadUserPermission: async ({ commit }) => {
			const response = await userAPI.lookupUserPermission()
			commit('setUserPermission', response.data)
		},
		lookupLicense: async ({ commit }, id) => {
			const response = await userAPI.lookupLicense(id)
			console.log(response)
			commit('setLicense', response.data)
		},
		loginUser: async ({ commit }, deviceToken) => {
			return await userAPI.signin({ deviceToken })
		},
	},
}

export default User
